import React from "react";
import * as icons from "@ant-design/icons";

/**
 * 动态渲染antd-icons的方法
 * @param props
 * @returns
 */
export default (props) => {
  const { type = "", ...rest } = props;
  const IconComp = icons[type];
  return <IconComp {...rest} />;
};
